export default "__VITE_ASSET__BAYPhtfT__"